import { useEffect, useState } from 'react';
import { Modal, Button, Image } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import { BACK_UP_IMG, PC_CDN_HOST } from '@/const/staticURL';
import { request } from '@/config/request';
import { OrderCancelPopupsResp } from '@/service/order';
import { isLogin } from '@/config/request/login';
import './index.scss';
import ExpandLine from '@/common/icons/ExpandLine';
import CollapseLine from '@/common/icons/CollapseLine';
import { formatDateCN2JP } from '@/utils';

// 首页取消订单弹窗
const OrderCancelModal = () => {
    const login = isLogin();
    const navigate = useNavigate();
    const { runAsync: apiGetCancelModalList } = useRequest(
        request.order.orderSearch.orderCancelPopups,
        {
            manual: true
        }
    );
    const { runAsync: apiCancelModalConfirm } = useRequest(
        request.order.orderSearch.orderCancelPopupsConfirm,
        {
            manual: true
        }
    );
    const [openList, setOpenList] = useState<string[]>([]);
    const [modalData, setModalData] = useState<OrderCancelPopupsResp>({});
    useEffect(() => {
        login &&
            apiGetCancelModalList().then((res) => {
                res.data && setModalData(res.data);
                if (res.data?.orderList?.length === 1) {
                    res.data?.orderList[0].orderNo &&
                        setOpenList([res.data?.orderList[0].orderNo]);
                }
            });
    }, [apiGetCancelModalList, login]);
    // 订单展开关闭
    const toggleClick = (number: string) => {
        if (!number) return;
        if (openList.includes(number)) {
            setOpenList(openList.filter((item) => item !== number));
            return;
        }
        setOpenList([...openList, number]);
    };

    // 稍后查看点击
    const laterClick = () => {
        apiCancelModalConfirm({
            confirmType: 2
        }).then((res) => {
            if (res.success) {
                setModalData({});
            }
        });
    };

    // 立即查看点击，携带订单号跳转订单列表页，如果是单个订单，则跳转订单详情
    const confirmClick = () => {
        apiCancelModalConfirm({
            confirmType: 1
        }).then((res) => {
            if (res.success) {
                setModalData({});
                const orderNoList: string[] = [];
                modalData.orderList?.forEach((item) => {
                    orderNoList.push(item.orderNo || '');
                });
                if (orderNoList?.length > 1) {
                    navigate(`/order/index?orderNoList=${orderNoList}`);
                } else if (orderNoList.length === 1) {
                    navigate(`/order/detail?orderNo=${orderNoList[0]}`);
                }
            }
        });
    };
    return (
        <>
            {modalData.orderList && modalData.orderList.length > 0 ? (
                <Modal
                    title=""
                    open={true}
                    footer={null}
                    closeIcon={null}
                    width={420}
                    className="cancel-modal"
                >
                    <img
                        className="cancel-bg"
                        src={PC_CDN_HOST + 'cancel_bg.png'}
                        alt=""
                    />
                    <div className="cancel-logo-box">
                        <img
                            className="cancel-logo"
                            src={PC_CDN_HOST + 'cancel_frog.png'}
                            alt=""
                        />
                    </div>
                    <div className="cancel-content">
                        <div className="text-sm mt-[58px]">
                            {window._$m.t(
                                '您有{{num}}笔订单被取消，取消原因：{{reason}}',
                                {
                                    data: {
                                        num: modalData.orderList.length,
                                        reason: modalData.cancelReason
                                    }
                                }
                            )}
                        </div>
                        <div>
                            {window._$m.t('退款事宜可与客服进行联系确认')}
                        </div>
                        <div className="cancel-orders">
                            {modalData.orderList.map((item) => (
                                <div
                                    key={item.orderNo}
                                    className="cancel-order-item"
                                >
                                    <div>
                                        <span className="float-left">
                                            {window._$m.t('订单编号')}
                                        </span>
                                        <span className="relative left-20">
                                            {item.orderNo}
                                        </span>
                                        <span
                                            className="float-right cursor-pointer"
                                            onClick={() =>
                                                toggleClick(item.orderNo || '')
                                            }
                                        >
                                            {openList.includes(
                                                item.orderNo || ''
                                            ) ? (
                                                <CollapseLine />
                                            ) : (
                                                <ExpandLine />
                                            )}
                                        </span>
                                    </div>
                                    {openList.includes(item.orderNo || '') && (
                                        <div>
                                            <div className="flex justify-between">
                                                <span>
                                                    {window._$m.t('下单时间')}
                                                </span>
                                                <span>
                                                    {formatDateCN2JP(
                                                        item.createdTime
                                                    )}
                                                </span>
                                            </div>
                                            <div>
                                                <span className="float-left">
                                                    {window._$m.t('商品图片')}
                                                </span>
                                                <div className="cancel-item-imgs">
                                                    {/** 只显示前4个取消商品sku的图片 */}
                                                    {item.orderItemList
                                                        ?.filter(
                                                            (_, index) =>
                                                                index < 4
                                                        )
                                                        .map((product) => (
                                                            <div
                                                                key={product.id}
                                                                className="w-[60px] h-[60px] mr-[5px] relative"
                                                            >
                                                                <Image
                                                                    className="w-[60px] h-[60px]"
                                                                    src={
                                                                        product.productImg
                                                                    }
                                                                    fallback={
                                                                        BACK_UP_IMG
                                                                    }
                                                                    alt=""
                                                                />
                                                                <div className="cancel-item-num">
                                                                    x
                                                                    {
                                                                        product.productQuantity
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="cancel-btns">
                        <Button className="min-w-[100px]" onClick={laterClick}>
                            {window._$m.t('稍后查看')}
                        </Button>
                        <Button
                            className="hover:opacity-80"
                            style={{
                                marginLeft: '15px',
                                minWidth: '100px',
                                fontSize: '14px',
                                color: '#fff',
                                borderColor: '#FF5010FF',
                                background: '#FF5010FF'
                            }}
                            onClick={confirmClick}
                        >
                            <span>{window._$m.t('立即查看')}</span>
                        </Button>
                    </div>
                </Modal>
            ) : (
                <></>
            )}
        </>
    );
};
export default OrderCancelModal;
